<template>
    <div class="change-company">
        <div class="container section">
            <div class="row">
                <div class="col-lg-4">
                    <div class="title">
                        Skift virksomhed
                    </div>
                    <br>
                    <p>
                        Som super admin kan du her ændre hvilken virksomhed du ønsker at se data for. Når du vælger en virksomhed, vil applikation opdatere og du ser nu de samme data, som virksomhedens egne brugere ser det.
                    </p>
                </div>
                <div class="col-lg-8">
                    
                    <div class="company" v-if="companies && !loading" v-for="company in companies" :key="company.uuid">
                        <div class="name">
                            {{ company.name }}
                            <br>
                            <span v-if="company.api_provider.name === 'Ordrestyring'" style="background:#339861;color:#fff;font-size:12px;padding:2px 6px;margin-top:4px;display:inline-block;border-radius:3px;">
                                {{ company.api_provider.name }}
                            </span>
                            <span v-else style="background:#852240;color:#fff;font-size:12px;padding:2px 6px;margin-top:4px;display:inline-block;border-radius:3px;">
                                {{ company.api_provider.name }}
                            </span>
                        </div>
                        <div class="action" @click="changeCompany(company)">
                            Skift til denne virksomhed
                            <i class="fas fa-arrow-right" />
                        </div>
                    </div>

                    <box-loading height="350" v-else />

                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .company {
        background: $color--white;
        padding: $padding--main;
        box-shadow: $boxshadow--main;
        border-radius: $borderradius--main;
        margin-bottom: $margin--small;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .name {
            font-weight: 600;
        }

        .action {
            background: $color--dark;
            color: $color--white;
            padding: 4px 10px;
            border-radius: $borderradius--main;
            cursor: pointer;

            &:hover {
                opacity: 0.9;
            }
        }
    }

</style>

<script>
import * as companyService from '@/services/companyService'

export default {
    data () {
        return {
            loading: false,
            companies: null
        }
    },
    created () {
        this.getCompanies()
    },
    methods: {
        getCompanies () {
            this.loading = true
            let params = {
                include: 'api_provider'
            }
            companyService.findAll(params, (response) => {
                this.companies = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        changeCompany (company) {
            let body = {
                company_uuid: company.uuid
            }
            companyService.change(body, (response) => {
                this.$toastr('success', 'Virksomhed opdateret. Opdaterer siden.', 'Sådan!')
                setTimeout(() => {
                    window.location.href = '/'
                }, 1000)
            }, (err) => {
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// changeCompany.vue?674858ec